import React from 'react';
import { Box, HStack, Spacer, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { LocationHeaderButton } from '../../atoms/LocationHeaderbutton';
import { useDispatch, useSelector } from 'react-redux';
import {
  initStateData,
  SetMessageData
} from '../../../redux/message/MessageSlice';
import { RootState } from '../../../redux/RootReducer';

export const modalEnum = {
  None: 0,
  Message: 1,
  MessageList: 2,
  Mentenance: 3,
  Logout: 4
};

export const LocationHeader: React.FC = () => {
  const roleStateData = useSelector((state: RootState) => state.login);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ButtonClick = (type: number) => () => {
    if (type === modalEnum.Mentenance) {
      navigate('/admin/admin_users');
    } else if (type === modalEnum.MessageList) {
      navigate('/messageList');
    } else if (type === modalEnum.Message) {
      dispatch(SetMessageData({ data: initStateData }));
      navigate('/message');
    } else if (type === modalEnum.Logout) {
      navigate('/login');
    }
  };

  return (
    <>
      <HStack h='70px' backgroundColor='gray.600'>
        <Box>
          <Text ml='5' fontSize='35px' color='white'>
            運行管理システム
          </Text>
        </Box>
        <Spacer />
        {roleStateData.role !== 3 && (
          <Box>
            <LocationHeaderButton
              buttonClick={ButtonClick(modalEnum.Message)}
              buttonText='メッセージ'
            />
          </Box>
        )}
        {roleStateData.role !== 3 && (
          <Box>
            <LocationHeaderButton
              buttonClick={ButtonClick(modalEnum.MessageList)}
              buttonText='メッセージ一覧'
            />
          </Box>
        )}
        {roleStateData.role === 1 && (
          <Box>
            <LocationHeaderButton
              buttonClick={ButtonClick(modalEnum.Mentenance)}
              buttonText='メンテナンス'
            />
          </Box>
        )}
        <Box>
          <LocationHeaderButton
            buttonClick={ButtonClick(modalEnum.Logout)}
            buttonText='ログアウト'
          />
        </Box>
      </HStack>
    </>
  );
};
